import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { clsx } from "clsx";
import LazyImage from "../LazyImage/index.js";
import { KAVATAR_SIZE_CLASSES } from "./constants.js";
import { StatusCircle } from "./StatusCircle.js";
import { getAvatarSrc, getDefaultAvatarSrc } from "./utils.js";
const Avatar = ({ src: srcProp, alt = 'avatar', observerProps, imgClassName: imgClassNameProp, className, size = 's', isLazy = true, status, defaultAvatarColor = 'purple', userName, spanElProps, ...avatarProps })=>{
    const { src } = useMemo(()=>getAvatarSrc({
            src: srcProp,
            size
        }), [
        srcProp,
        size
    ]);
    const defaultAvatarSrc = useMemo(()=>getDefaultAvatarSrc({
            defaultAvatarColor,
            size
        }), [
        defaultAvatarColor,
        size
    ]);
    const sizeClasses = KAVATAR_SIZE_CLASSES[size];
    const imgClassName = clsx([
        'tw-w-full',
        'tw-h-full',
        'tw-rounded-full',
        'tw-overflow-hidden'
    ], imgClassNameProp);
    const defaultAvatar = /*#__PURE__*/ jsx("span", {
        className: imgClassName,
        style: {
            backgroundImage: `url(${defaultAvatarSrc})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
    });
    const renderImage = (imageSrc, renderLazily)=>renderLazily ? /*#__PURE__*/ jsx(LazyImage, {
            className: imgClassName,
            imgClassName: "tw-object-cover tw-w-full tw-h-full",
            placeholder: defaultAvatarSrc,
            src: imageSrc,
            alt: alt,
            observerProps: observerProps
        }) : /*#__PURE__*/ jsx("img", {
            className: imgClassName,
            style: {
                objectFit: 'cover'
            },
            src: src,
            alt: alt
        });
    return /*#__PURE__*/ jsxs("span", {
        ...avatarProps,
        ...spanElProps,
        className: clsx('tw-relative tw-inline-flex tw-items-center tw-justify-center tw-flex-shrink-0', className, sizeClasses),
        children: [
            src ? renderImage(src, isLazy) : defaultAvatar,
            'xs' !== size && status && /*#__PURE__*/ jsx(StatusCircle, {
                size: size,
                status: status,
                userName: userName,
                className: clsx({
                    'tw-bg-success-400': 'online' === status,
                    'tw-bg-neutral-light-700': 'offline' === status
                })
            })
        ]
    });
};
const Avatar_Avatar = Avatar;
export default Avatar_Avatar;
